import { useState } from 'react';

function useDepartmentFilter(setCurrentPage) {
    const [selectedDepartments, setSelectedDepartments] = useState([]);

    const handleDepartmentChange = (dept) => {
        setSelectedDepartments(prev => {
            if (prev.includes(dept)) {
                return prev.filter(d => d !== dept);
            } else {
                return [...prev, dept];
            }
        });
        if (setCurrentPage) {
            setCurrentPage(1); // Reset to first page when departments change
        }
    };

    return { selectedDepartments, handleDepartmentChange, setSelectedDepartments };
}

export default useDepartmentFilter;